import { render, staticRenderFns } from "./LjReport.vue?vue&type=template&id=70bf4eec&scoped=true"
import script from "./LjReport.vue?vue&type=script&lang=js"
export * from "./LjReport.vue?vue&type=script&lang=js"
import style0 from "./LjReport.vue?vue&type=style&index=0&id=70bf4eec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bf4eec",
  null
  
)

export default component.exports